/**
 * @generated SignedSource<<3c992eb555fd4d2619e806b322c55e89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetRequest = {
  id: string;
};
export type hooksFeatureFlagsQuery$variables = {
  input: GetRequest;
  skip: boolean;
};
export type hooksFeatureFlagsQuery$data = {
  readonly getUser?: {
    readonly featureFlags: ReadonlyArray<string> | null;
    readonly id: string;
  };
};
export type hooksFeatureFlagsQuery = {
  response: hooksFeatureFlagsQuery$data;
  variables: hooksFeatureFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "getUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksFeatureFlagsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksFeatureFlagsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaa959c89fde1167e2e2bc548bd15dce",
    "id": null,
    "metadata": {},
    "name": "hooksFeatureFlagsQuery",
    "operationKind": "query",
    "text": "query hooksFeatureFlagsQuery(\n  $input: GetRequest!\n  $skip: Boolean!\n) {\n  getUser(input: $input) @skip(if: $skip) {\n    id\n    featureFlags\n  }\n}\n"
  }
};
})();

(node as any).hash = "fac76d70959926e637e1ed321b77c5b4";

export default node;
